<template>
    <div>
        <loading-dom v-if="isShowLoading" style="position: fixed; z-index: 999999;"></loading-dom>
		<skeleton-screen-card style="min-height: 100vh; overflow: hidden;" v-if="!isCloseSkeletonScreen" :data="5" />
		
		<!-- 列表 -->
		<div v-show="isCloseSkeletonScreen" class="live_item">
			<!-- 仅自己可见 -->
			<div
				class="is_only_self_show"
				v-if="live_msg && live_msg.only_self_show && live_msg.only_self_show === 'yes' && u_id == live_msg.u_id"
			>仅自己可见</div>
			
			<!-- 仅粉丝可见 -->
			<div
				class="is_only_fans_show"
				v-if="live_msg && live_msg.is_fans_show && live_msg.is_fans_show == '1'"
			>仅粉丝可见</div>

			<template v-if="live_msg">
				<div class="live_header">
					<dl class="user_detail" v-if="live_msg && live_msg.image">
						<!-- 头像 -->
						<dt @click.stop.prevent="handleClickUserPage">
							<img :src="live_info && live_info.l_image" alt="用户头像" />
						</dt>

						<!-- 右侧 -->
						<dd>
							<h4>
								<span class="user_name">{{ live_info && live_info.remark_name || live_info && live_info.l_title }}</span>
								<template v-if="live_info && live_info.user_medals_tail && live_info.user_medals_tail.length > 0">
									<span
										class="user_symbol"
										v-for="(item, index) in live_info.user_medals_tail"
										:key="index"
										@click.stop.prevent="openNative('medal_page')"
									>
										<img :src="item.image" alt="" />
									</span>
								</template>
							</h4>
							<p v-if="live_msg.rec_time">{{ live_msg.rec_time_desc }}&nbsp;&nbsp;&nbsp;{{ live_msg.view_num }}</p>
						</dd>
						
						<!-- 最右侧 -->
						<div class="right_btns" v-if="!isSelf">
							<!-- 开通VIP -->
							<button
								class="open_vip"
								v-if="live_info && live_info.is_vip != 'yes' && live_info && live_info.serve_vip == 'yes'"
								@click.stop.prevent="openNative('vip_product')"
							>开通VIP</button>
							
							<!-- 私信 -->
							<button
								class="letter_msg"
								v-else-if="live_info && live_info.can_letter == 'yes'"
								@click.stop.prevent="openNative('direct_msg')"
							>私信</button>
							
							<!-- 关注 - 已关注 - 特别关注 -->
							<button
                                v-if="live_info"
								:class="['blockdivFollow', {
							        // 特别关注
							        is_special: live_info.is_follow != 'no' && live_info.is_special == 'yes',
							        // 普通关注
							        is_follow: live_info.is_follow != 'no' && live_info.is_special != 'yes',
							        // 未关注
							        is_no_follow: live_info.is_follow == 'no',
							        // 没有私信的情况下（这样就左边一个样式了
							        is_only: live_info.can_letter != 'yes'
							    }]" @click.stop.prevent="followUserFn"
							>
							    {{ live_info.is_follow != 'no'? (live_info.is_special == 'yes'? '已特别关注': '已关注'): '关注' }}
							</button>
						</div>
					</dl>
				</div>

				<div class="live_content_box">
                    <!-- 1|| -->
					<div v-if="(live_msg.kind === 'vip')">
						<div v-if="(live_msg.is_show === 'no' || !live_msg.content)">
							<div class="members_only">
								<div
									:class="['members_only_free', apptextSize]"
									v-html="strParseFace(live_msg.brief)"
								>
								</div>
								<div class="members_only_box">
									<div>
										<p v-if="live_msg.vip_group_info">所属分组：{{ live_msg.vip_group_info }}</p>
										<div class="vip_nosee_company">
											<span></span>
											<div>
												<p>本条为收费观点</p>
												<p class="vip_nosee_company_small">请开通会员后查看</p>
											</div>
											<div class="vip_company_info" @click.stop.prevent="openNative('vip_product')">
												<span>立即开通</span>
												<span v-if="live_info" class="vip_company_info_small">{{live_info.product_price}}元/{{live_info.product_price_per_cycle}}</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
                        <!-- 1|| -->
						<div v-if=" (live_msg.is_show === 'yes' && live_msg.content)">
							<div :class="['member_brief', apptextSize]" v-html="strParseFace(live_msg.brief)"></div>
							<div class="member_pad"></div>
							<div class="member_news_box">
								<div class="member_news">
									<div class="member_news_header" @click.stop.prevent="handleClickGroupInfo">
										<dl>
											<dt>
												<img alt :src="require('@/assets/images/icon-vip-yellow@2x.png')" />
											</dt>
											<dd>
												<h4>
													以下内容会员独享
													<span v-if="live_msg.vip_group_info">[{{ live_msg.vip_group_info }}]</span>
												</h4>
												<!-- <p>本收费产品由{{live_msg.company}}提供</p> -->
											</dd>
										</dl>
									</div>

									<div :class="['member_news_contents', apptextSize]" v-html="strParseFace(vipContent)"></div>

									<div
										v-if="live_msg.menus && live_msg.menus.length > 0 || live_msg.image && live_msg.image.length > 0"
										@click.stop
									>
										<image-viewpoint
											:msg="live_msg || live_msg.image"
											applicationPage="detail"
										></image-viewpoint>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!-- 附件 -->
					<div v-if="live_msg.file && live_msg.file.length > 0">
						<div class="file_wrap24_wrap">
							<div
								class="file_wrap24"
								v-for="(item, index) in live_msg.file"
								:key="index"
								@click.stop.prevent="handleClickFileDetail(item, index)"
							>
								<div class="file_wrap">
									<div class="file_box">
										<div :class="['file_box_img', item.file_type + '_img']"></div>
										<div
											class="file_box_view_rf"
											:data-type="item.file_type"
											:data-name="item.file_name"
											:data-link="fileLinkFn(item)"
										><p>{{ item.file_name }}</p><span>({{item.file_size}})</span></div>
										<button
											class="file_box_download"
											:data-name="item.file_name"
											:data-link="item.file_link"
										></button>
									</div>
								</div>
							</div>
						</div>
					</div>
					
					<!-- 参考研报 -->
					<div class="research_report" v-if="live_msg && live_msg.research_report && live_msg.research_report.length > 0">
						<p>参考研报</p>
						<div>
							<div
								class="research_wrap"
								v-for="(item, index) in live_msg.research_report"
								:key="index"
								@click.stop.prevent="goDetail(item)"
							>
								<div class="research_left">{{item.title}}</div>
								<div class="research_right">
									<span class="research_source">{{item.source}}</span><span class="research_pub_time">{{item.pub_time}}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>

			<!-- 底部样式布局 -->
			<div class="statement_wrap" v-if="live_msg && false">
				<p>&copy;{{ live_msg.copyright }}</p>
			</div>

			<!-- 赞赏 - 点赞 -->
			<div
				class="appreciate_support_wrap"
				v-if="live_msg"
			>
				<button
					:class="['appreciate_btn', {
						is_new: hasShowRewardNewIcon
					}]"
					@click.stop.prevent="handleClickReward('appreciate')"
					v-if="live_info && live_info.l_allow_reward == 'yes' || live_info && live_info.cash_reward_switch == 1"
				>赞赏</button>
				<button
					:class="['support_btn', {
						is_support: isSupport == 'yes'
					}]"
					@click.stop.prevent="handleClickToLike"
				>{{live_msg.support_num}}</button>
			</div>

			<!-- 赞赏 -->
			<div class="reward_wrap" v-if="live_msg">
				<p>{{live_msg.reward_intro}}</p>
				<div
					:class="['reward_wrap_list', {
						bindLeft: live_msg.reward_list && live_msg.reward_list.length > 10
					}]"
					@click.stop.prevent="openNative('jump_reward_page')"
				>
					<div
						v-for="(item, index) in live_msg.reward_list"
						:key="index"
						:style="{
							backgroundImage: 'url(' + item.u_avatar + ')'
						}"
					></div>
				</div>
			</div>

			<!-- 分享到 - 朋友圈 - 微信 - QQ - 微博 -->
			<div class="share_list">
				<span>分享到</span>
				<button
					v-for="(item, index) in shareList"
					:key="index"
					:class="[item.type]"
					@click.stop.prevent="shareCard(item)"
				></button>
			</div>

			<!-- 投资参考提示 -->
			<div class="risk_hint" v-if="live_msg">
                <p v-if="false">会员区内容系合规投顾机构版权，不作为投资依据，据此操作风险自负，投资有风险，入市须谨慎。</p>
				<p>{{ live_msg.disclaimer }}</p>
                <p v-if="false">&copy;{{ live_msg.copyright }}</p>
			</div>
		</div>

		<!-- 评论 -->
		<comment-nav
			v-if="live_msg"
			:content_id="id.toString()"
			:content_kind="'live_msg'"
			ref="comment"
			:card_user="live_info"
			:card_user_info="live_msg"
            :apptextSize="apptextSize"
		/>
		
		<van-action-sheet
		  v-model:show="cancelFollowShow"
		  :actions="actions"
		  cancel-text="取消"
		  description="确定不在关注此人？"
		  close-on-click-action
		  @select="cancelFollowFn"
		  safe-area-inset-bottom
		/>
        <!-- signToastDom -->
        <sign-toast-dom
            v-if="isShowSignCard"
            :url="isShowSignUri"
        ></sign-toast-dom>

        <!-- userMToastDom -->
        <user-m-toast-dom
            v-if="isShowSatiCard"
            :url="isShowSatiUri"
        ></user-m-toast-dom>
    </div>
</template>
<script>
import { u_id, appversion, source, textSize, detailTextSize } from "@/utils/urlQuery";
import userHomeApi from "@/api/user_home/index.js";
import { highLight, isLoginInfo, reSetUrl, highLightAtUser, parseUrlLink } from "@/utils/index";
import { Dialog, ActionSheet } from "vant";
import "@/utils/flexible";
export default {
    name: "",
    data() {
        return {
            isCloseSkeletonScreen: false,
            id: parseInt(this.$route.query.id) || 0,
            shareList: [
                {
                    name: "朋友圈",
                    type: "Moments",
                    status: "wechatMoments"
                }, {
                    name: "微信",
                    type: "WeChat",
                    status: "wechat",
                }, {
                    name: "QQ",
                    type: "QQ",
                    status: "qq"
                }, {
                    name: "微博",
                    type: "WeiBo",
                    status: "sinaWeibo"
                }
            ],
            user_info: null,
            live_info: null,
            live_msg: null,
            apptextSize: detailTextSize || textSize,
            isSupport: 'no',
            supportNum: 0,
            supportStr: "",
            reqLoading: false,
            vipContent: "",
            faceList: { "\u5fae\u7b11": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_weixiao@3x.png", "\u9707\u60ca": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_zhenjing@3x.png", "\u6487\u5634": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_piezui@3x.png", "\u8272": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_se@3x.png", "\u5927\u54ed": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_daku@3x.png", "\u9177": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_ku@3x.png", "\u594b\u6597": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_fendou@3x.png", "\u7591\u95ee": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_yiwen@3x.png", "\u574f\u7b11": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_huaixiao@3x.png", "\u9634\u9669": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_yinxian@3x.png", "\u4eb2\u4eb2": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_qinqin@3x.png", "\u53ef\u601c": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_kelian@3x.png", "OK": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_OK@3x.png", "\u98de\u543b": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_feiwen@3x.png", "\u60b2\u4f24": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_beishang@3x.png", "\u6c57": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_han@3x.png", "\u6342\u8138": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_wulian@3x.png", "\u5927\u6012": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_danu@3x.png", "\u6012\u706b": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_nuhuo@3x.png", "\u5455": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_ou@3x.png", "dog": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_dog@3x.png", "\u94b1": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_qian@3x.png", "\u5410\u8840": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_tuxue@3x.png", "\u6342\u5634\u7b11": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_wuzuixiao@3x.png", "\u61f5": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_meng@3x.png", "\u53cb\u5584": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_youshan@3x.png", "\u60e8": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_can@3x.png", "\u4e27": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_sang@3x.png", "\u6311\u7709": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_tiaomei@3x.png", "\u7b11\u54ed": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_xiaoku@3x.png", "\u7761\u89c9": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_shuijiao@3x.png", "\u53ef\u7231": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_keai@3x.png", "\u5657": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_pu@3x.png", "\u6c14\u6124": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_qifen@3x.png", "\u5927\u7b11": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_daxiao@3x.png", "\u611f\u5192\u4e86": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_kouzhao@3x.png", "\u5201\u96be": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_diaonan@3x.png", "\u67e0\u6aac": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_ningmeng@3x.png", "\u771f\u725b": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_zhenniu@3x.png", "\u65e9\u5b89": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_zaoan@3x.png", "\u665a\u5b89": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_wanan@3x.png", "\u7a7a\u4ed3": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_kongcang@3x.png", "\u6ee1\u4ed3": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_mancang@3x.png", "\u51cf\u4ed3": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_jiancang@3x.png", "\u52a0\u4ed3": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_jiacang@3x.png", "\u6da8": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_zhang@3x.png", "\u8dcc": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_die@3x.png", "\u8e29": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_cai@3x.png", "\u9876": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_ding@3x.png", "\u80dc\u5229": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_shengli@3x.png", "\u91d1\u5e01": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_jinbi@3x.png", "dog\u6342\u8138": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/dog_wulian2021-08-23@3x.png", "dog\u7b11\u54ed": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/dog_xiaoku2021-08-23@3x.png", "\u7231\u5fc3": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/aixin2021-08-23@3x.png", "\u5315\u9996": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/bishou2021-08-23@3x.png", "\u6284\u5e95": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/chaodi2021-08-23@3x.png", "\u5403\u74dc": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/chigua2021-08-23@3x.png", "\u5403\u8089": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/chirou2021-08-23@3x.png", "\u6253call": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/dacall2021-08-23l@3x.png", "\u4e8c\u54c8": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/erha2021-08-23@3x.png", "\u7ea2\u5305": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/hongbao2021-08-23@3x.png", "\u97ed\u83dc": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/jiucai2021-08-23@3x.png", "\u9152": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/jiu2021-08-23@3x.png", "\u88c2\u5f00": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/liekai2021-08-23@3x.png", "\u5e72\u676f": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/pijiu2021-08-23@3x.png", "\u5e86\u795d": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/qingzhu2021-08-23@3x.png", "\u5fc3\u788e": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/xinsui2021-08-23@3x.png", "\u836f": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/yao2021-08-23@3x.png", "666": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/666_v3.png", "\u767d\u773c": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/baiyan_v3.png", "\u6253\u8138": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/dalian_v3.png", "\u9f13\u638c": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/guzhang_v3.png", "\u62a0\u9f3b": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/koubi_v3.png", "\u96be\u8fc7": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/nanguo_v3.png", "\u53f9\u6c14": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/tanqi_v3.png", "\u6293\u72c2": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/zhuakuang_v3.png", "\u9f87\u7259": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/ziya_v3.png", "\u4e70": "https:\/\/img1-cdn-picsh.aigupiao.com\/m\/image_lib\/2022-03-21\/0e2f6f9ac9666b0cbf46bbf18fb15528=200X200.png", "\u8df3\u6c34": "https:\/\/img1-cdn-picsh.aigupiao.com\/m\/image_lib\/2022-03-21\/d938c427247c2c9dfc0c0ff3edee75ed=200X200.png", "\u7a7a": "https:\/\/img1-cdn-picsh.aigupiao.com\/m\/image_lib\/2022-03-21\/7b5cc2714dc25772900d3c8924237b22=200X200.png", "\u591a": "https:\/\/img1-cdn-picsh.aigupiao.com\/m\/image_lib\/2022-03-21\/4fe79dc6598e28957f02439e81eb7a68=200X200.png", "\u5403\u9762": "https:\/\/img1-cdn-picsh.aigupiao.com\/m\/image_lib\/2022-03-21\/140199629c06eca7f7f4c63cec870bd0=200X200.png", "\u68ad\u54c8": "https:\/\/img1-cdn-picsh.aigupiao.com\/m\/image_lib\/2022-03-21\/90cb956f181acaf875b1c7a857937112=200X200.png", "\u5356": "https:\/\/img1-cdn-picsh.aigupiao.com\/m\/image_lib\/2022-03-21\/2263373d61c164c7ecd0d2551dc82323=200X200.png", "\u62b1\u62f3": "https:\/\/img1-cdn-picsh.aigupiao.com\/m\/image_lib\/2022-03-21\/f838a3021272c8fdfc580ad8992be7a7=100X100.png", "\u7948\u7977": "https:\/\/img1-cdn-picsh.aigupiao.com\/m\/image_lib\/2022-03-21\/cf0006b5b512a9e8d3946b19166d28c2=100X100.png", "\u63e1\u624b": "https:\/\/img1-cdn-picsh.aigupiao.com\/m\/image_lib\/2022-03-21\/e2d6ab55fc734846651fddf0fb363a06=100X100.png" },
            // 
            scroll_btm: this.$route.query.scroll_btm || 'no', // 定位
			
			cancelFollowShow: false,
			actions: [
				{ name: '确定' }
			],
			isSelf: false, // 是不是自己查看
			
			hasShowRewardNewIcon: false, // 是否显示赞赏new的标志
            isShowLoading: false,
            
            isShowSignCard: false, // 是否展示去签约的弹窗
            isShowSignUri: "",

            isShowSatiCard: false,
            isShowSatiUri: "",
        }
    },
    components: {
        imageViewpoint: () => import("@/components/userHome/imageViewpoint.vue"),
        CommentNav: () => import("@/components/CommentNav/comment.vue"),
        skeletonScreenCard: () => import("@/components/userHome/components/skeletonScreen.vue"),
        loadingDom: ()=> import("@/page/app/page_loading.vue"),
        signToastDom: () => import("@/components/signToast.vue"),
        userMToastDom: () => import("@/components/user_m_toast.vue"),
		[ActionSheet.name]: ActionSheet,
    },
    created() {
        this.getLiveMsg();

        // 点赞状态 -start
        let supportStr = 'live_msg_' + this.id;
        // isSupport
        if(localStorage && localStorage[supportStr]) {
            let value = localStorage[supportStr] || 'no';
            this.isSupport = value;
        }
        this.supportStr = supportStr;
        // 点赞状态 - end
		
		// 赞赏状态 - start
		let hasShowRewardNewIcon = true;
		if(localStorage && localStorage['hasShowRewardNewIcon']) {
		    let value = localStorage['hasShowRewardNewIcon'] || 'yes';
		    hasShowRewardNewIcon = (value == 'yes'? true: false);
		}
		this.hasShowRewardNewIcon = hasShowRewardNewIcon;
		// 赞赏状态 - end
		
		$("body").on("click", '.p-a-link', function(e) {
		    e.stopPropagation();
		    e.preventDefault();
		    let type = $(this).attr('data-type'), id = $(this).attr('data-id'), name = $(this).attr('data-name'), code = $(this).attr('data-code')
		    let query = {}, state = ""
		    if(type == 'stock') {
		        query.name = name;
		        query.code = code;
		        state = 'stock_page';
		    } else if(type == 'theme') {
		        query.id = id;
		        state = 'theme_page';
		    } else if(type == 'at_user') {
                let role = $(this).attr('data-role');
                state = 'person_page';
                query.o_kind = role;
                query.id = id;
            }
		    _this.openNative(state, query)
		})

        $("body").on("click", '.p-url-link', function(e) {
            e.stopPropagation();
            e.preventDefault();
            let url = $(this).attr('url');
            // followup_url
            _this.$srH5CallNativeMethodApp('navigateToAppScheme', {
                url: url
            })
        })

        
        let _this = this;
        window.srNativeCallH5Method = (data) => {
            let params = null;
            params = handleSpecialCharacters(data);
            let obj = {};
            if(params && params.params) {
                obj = params.params;
            }

            // 更新RSA vip数据
            if(params.method_name == 'decrypt_rsa_content') {
                _this.vipContent = obj.content;
                _this.$forceUpdate();
            }

            if(params.method_name == 'set_font_size') {
                this.apptextSize = obj.font_size;

                this.$nextTick(function () {
                    
                    // box_scroll的位置 需要变化
                    let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
                    if($('.comment_reply_title_input_empty').offset().top == scrollTop){
                        //未到滚动部分
                        window.box_scroll = $('.comment_reply_title_input').offset().top;
                    }
                    else{
                        //已到滚动部分
                        window.box_scroll = $('.comment_reply_title_input_empty').offset().top;
                    }
                    
                    // 展开收起全文 需要变化
                    window.expandComment();
                });
            }

            // 下拉刷新
            if(params.method_name == "reload_page_list") {
                
                // 更新列表
                if(obj.reload_user_info == 'yes') {
                    _this.getLiveMsg('reload');
                }

                // 是否回到顶部
                if(obj.is_fixed_top == 'yes') {
                    
                }
            }
			
			// 更新頁面數據
			if(params.method_name == "call_login_info")  {
				let url = reSetUrl(obj);
				window.history.replaceState(null, null, url);
				window.location.reload(true);
			}

            if(_this.$refs['comment']) {
                _this.$refs['comment'].srNativeCallH5Method && _this.$refs['comment'].srNativeCallH5Method(data)
            }
        };

        window.srNativeRsaContent = (content, id) => {
            _this.vipContent = content;
            this.$forceUpdate();
        }

        function handleSpecialCharacters(jsonStr) {
            let obj = {};
            if (jsonStr && Object.prototype.toString.call(jsonStr) == "[object String]" && jsonStr != 'null') {
                jsonStr = jsonStr.replace(/\n/g, "\<br/>");
                obj = JSON.parse(jsonStr)
            }
            return obj;
        }
    },
    watch: {
        user_info: {
            handler(newVal, oldVal) {
                this.$srH5CallNativeMethodApp('notice_vip_details', newVal)
            },
            deep: true//监听父组件数据变化
        }
    },
    mounted() {
    },
    methods: {
        // 获取会员消息列表
        async getLiveMsg(type) {
            // act=msg_detail
            // m_id=2779380
            // newest=yes
            
            let res = await userHomeApi.getLiveMsg({
                act: "msg_detail",
                m_id: this.id,
                newest: "yes"
            });

            if(res && res.rslt == 'succ') {
                if(res && res.live_msg && res.live_msg.about_theme_list && res.live_msg.about_theme_list == '') {
                    res.live_msg.about_theme_list = []
                }
                try {
                    if(res.live_msg && res.live_msg.is_true_vip && res.live_msg.is_true_vip == 'no' && u_id != res.live_info.u_id) {
                        this.isShowLoading = true;
                        setTimeout(()=>{
                            this.isShowLoading = false;
                        }, 1000)
                    }
                } catch(e) {
                    console.info(e,'errorInfo')
                }
                
                this.user_info = res;
                this.live_msg = res.live_msg;
                if(res.live_info.is_follow == 'no') {
                    res.live_info.remark_name = "";
                }
                let APVERSION = appversion || "1160";
                if(APVERSION) {
                    if(APVERSION.indexOf(".")>-1) {
                        APVERSION = APVERSION.split(".").join('')
                    }
                }
                if(res.live_info.company == 'jf' && APVERSION >= 1251) {
                    if(res.live_msg.is_sign == 'no') {
                        this.isShowSignCard = true;
                        this.isShowSignUri = res.live_msg.sign_url;
                    } else {
                        let data = await userHomeApi.getTeacherInfo({
                            l_id: res.live_info.l_id
                        })
                        if(data.is_followup == 'yes') {
                            // followup_url
                            this.$srH5CallNativeMethodApp('jump_jufeng_page', {
                                url: data.followup_url
                            })
                        } else if(data.is_satisfaction_survey == 'yes') {
                            this.isShowSatiCard = true;
                            this.isShowSatiUri = data.satisfaction_survey_url;
                        }
                    }
                    
                }

                if(res.live_info.company == 'zf' && APVERSION >= 1273) {
                    if(res.live_msg.is_sign == 'no') {
                        this.isShowSignCard = true;
                        this.isShowSignUri = res.live_msg.sign_url;
                    } else {
                        let data = await userHomeApi.getTeacherInfo({
                            l_id: res.live_info.l_id
                        })
                        if(data.is_followup == 'yes') {
                            // followup_url
                            this.$srH5CallNativeMethodApp('jump_zhongfu_page', {
                                url: data.followup_url
                            })
                        } else if(data.is_satisfaction_survey == 'yes') {
                            this.isShowSatiCard = true;
                            this.isShowSatiUri = data.satisfaction_survey_url;
                        }
                    }
                    
                }
                this.live_info = res.live_info;
				
				// 判断ID是否相同（是否为本人） - 当前登录用户以及L_id请求到的u_id是否为同一个
				if(u_id == res.live_info.u_id) {
				    this.isSelf = true;
				} else {
				    this.isSelf = false;
				}

                this.supportNum = res.live_msg.support_num;

                if(res.live_msg.kind == 'vip' && res.live_msg.is_show === 'yes') {
                    this.$srH5CallNativeMethodApp('call_rsa_content', {
                        content: res.live_msg.content
                    })
                }
            }
			
			this.isCloseSkeletonScreen = true;
			
			if(type) {
			    this.$srH5CallNativeMethodApp('refresh_done',{})
			}
        },
        // 文件链接
        fileLinkFn(file_single) {
            let href_link = file_single.file_link, mc_base = "https://view.officeapps.live.com/op/view.aspx?src=";
            let newUrl = `https://view.xdocin.com/view?src=`;

            if(href_link.indexOf("img1-cdn-picsh.stock-ring.com/download/") > -1) {
                href_link =  `${newUrl}${encodeURIComponent(href_link)}`;
            } else {
                if(file_single.file_type !== 'pdf') {
                    href_link = (mc_base + file_single.file_link)
                }
                if(file_single.file_type === 'txt') {
                    href_link = file_single.file_link;
                }
            }
            return file_single;
        },
        // 点击附件跳转
        handleClickFileDetail(item, index) {
            console.info(item, index, "handleClikeFileDetail")
            this.openNative("file_page", {
                name: item.file_name,
                fileName: item.file_name,
                fileSize: item.file_size,
                fileType: item.file_type,
                fileLink: item.file_link
            });
        },
		// 点击关注按钮
		followUserFn() {
			if(!isLoginInfo()) {
				return
			}
		    // 未关注状态 -> 按钮为“关注”时
		    if(this.live_info.is_follow == 'no') {
		        // 调用关注API
		        this.followUser();
		    } else {
		        // 通知客户端打开对话框
		        this.cancelFollowShow = true;
		    }
		},
		
		// 点击关注用户
		async followUser(item) {
		    let res = await userHomeApi.setFollowLive({
		        id: this.live_info.l_id,
		        act: "follow",
		    })
		    if(res.rslt == 'succ') {
		        this.$set(this.live_info, 'is_follow', "yes");
                this.$srH5CallNativeMethodApp('notice_live_follow',{
                    'lid': this.live_info.l_id,
                })
		    }
		},
		async cancelFollowFn() {
			if(!isLoginInfo()) {
				return
			}
			let res = await userHomeApi.setFollowLive({
			    id: this.live_info.l_id,
			    act: "unfollow",
			})
			if(res.rslt == 'succ') {
			    this.$set(this.live_info, 'is_follow', "no");
			}
		},
        // 跳转APP页面
        openNative(type, query = {}) {
            let userInfo = this.live_info;
            console.info(userInfo,'当前用户的信息')
            let params = {
                kind: type, // 类型
            };

            // 同步传参
            params = {
                ...params,
                ...query
            }

            
            let APVERSION = appversion || "1160";
            if(APVERSION) {
                if(APVERSION.indexOf(".")>-1) {
                    APVERSION = APVERSION.split(".").join('')
                }
            }

            switch(type) {
                case "follow_page": // TA的关注
                    break;
                case "fans_page": // TA的粉丝
                    break;
                case "personal_detail": // TA的个人资料
                    break;
                case "vip_product": // 会员产品页面
					if(!isLoginInfo()) {
						return
					}
                    // no_vip_can_to_detail
                    if(this.live_msg.no_vip_can_to_detail){
                        const message = `<div class="vip_group_wrap_center">暂不支持开通</div>`
                        Dialog.alert({
                            title: '提示',
                            message,
                            className: 'custom-dialog',
                        }).then(() => {
                            // on close
                        });
                        return false;
                    }
                    if(APVERSION >= 1251 && this.live_info.company == 'jf' || (APVERSION >= 1233 && this.live_info.company == 'zf')) {
                        params.url = `/up/app/vip_product/wap/?l_id=${this.live_info.l_id}`;
                    } else if((APVERSION < 1251 && this.live_info.company == 'jf') || (APVERSION < 1273 && this.live_info.company == 'zf')) {
                        const message = `<div class="vip_group_wrap_center">请升级到最新版本！</div>`
                        Dialog.alert({
                            title: '提示',
                            message,
                        }).then(() => {
                            // on close
                        });
                        return
                    } else {
                        return
                    }
                    break;
                case "direct_msg": // 私信页面
                    break;
                case "match_page": // 模拟炒股大赛 主页
                    break;
                case "match_detail_page": // 模拟炒股大赛-详情页 - 可能需要ID
                    params.id = this.matchInfo.match_id;
                    break;
                case "file_page": // 附件
                    break;
                case "edit_personal_info": // 跳转编辑资料按钮
                    break;
                case "group_detail_page": // 查看某人的模拟组合页面
                    break;
                case "group_setting_page": // 模拟组合设置页面 - 应该是用户本人
                    break;
                case "group_transfer_warehousee": // 调仓页面
                    break;
                case "search_page": // 搜索页面 - 可能需要ID
                    break;
                case "medal_page":
                    // 暂时不区分
                    // ad  https://apis.aigupiao.com/MedalSystem/index&version=11.6.0
                    // ios https://apis.aigupiao.com/MedalSystem/index/u_id/77272/version/1160
                    params.url = `https://apis.aigupiao.com/MedalSystem/index/u_id/${userInfo.u_id}/version/${APVERSION}`
                    break;
                case "stock_page": // 股票详情页
                    break;
                case "theme_page": // 板块详情页
                    break;
                case "edit_background_image": // 修改背景图
                    params.img_url = this.backgroundImg
                    break;
                case "appreciate": // 赞赏
                    
                    break;
                case "jump_reward_page": //
                    break;
                case "person_page":
                    break;
            }

            this.$srH5CallNativeMethodApp('call_Native',params)
        },
        // 查看分组信息
        handleClickGroupInfo() {
            const message = `<div class="vip_group_wrap">${this.live_info.product_intro}</div>`
            Dialog.alert({
                title: '提示',
                message,
            }).then(() => {
                // on close
            });
        },
        // 点赞
        async handleClickToLike() {
            if(this.reqLoading) {
                return
            }
            this.reqLoading = true;
            //点赞功能
            let id = this.id
            let is_support = this.isSupport, support_num = this.supportNum;
            let type = 'support'
            if (is_support != "yes") {
                // 点赞
                is_support = "yes"
                support_num = parseInt(support_num) + 1;

                this.$srH5CallNativeMethodApp('support_style',{})
            } else {
                // 取消点赞
                is_support = 'no';
                type = 'cancel_support';
                if(support_num - 1 <= 0) {

                } else {
                    support_num = parseInt(support_num) - 1;
                }
            }

            
            this.isSupport = is_support;
            this.supportNum = support_num;

            let res = await userHomeApi.setAttitude({
                act: "publish",
                kind: "live_msg",
                type,
                id
            })

            if(res.rslt == 'succ') {
                localStorage[this.supportStr] = is_support;
            }
            this.reqLoading = false;
        },

        // 点击分享卡片
        shareCard(item) {
            this.$srH5CallNativeMethodApp('share_vip_msg',{
                kind: item.status
            })
            
        },

        // 调用赞赏
        handleClickReward() {
			localStorage['hasShowRewardNewIcon'] = 'no';
			this.hasShowRewardNewIcon = false;
            // 
            this.$srH5CallNativeMethodApp('appreciate',{
                
            })
        },
        
        // 字符串替换
        strParseFace(_str) {
            // 解析链接
            _str = parseUrlLink(_str);

            // 高亮@用户
            let to_info = this.live_msg.to_info;
            if(to_info && to_info.length > 0) {
                _str = highLightAtUser(_str, to_info);
            }

            // 高亮股票
            let stock_info = this.live_msg.stock_info;
            if(stock_info && stock_info.length > 0) {
                _str = highLight(_str, stock_info);
            }
			
            let json = this.faceList || [];
            let pattern1 = /\[.+?\]/g;
            let pattern2 = /\[.+?\]/;
            let contents = _str;

            let content = contents.match(pattern1);
            let str = contents;

            str = str && str.replace(/\r\n/g,"<br>")
            str = str && str.replace(/\n/g,"<br>");

            if (content && Object.keys(json).length > 0) {
                for (let i = 0; i < content.length; i++) {
                    let src = "";
                    for (let item in json) {
                        if ("[" + item + "]" === content[i]) {
                            src = `<img class="AGP_face" render="ext" src="${json[item]}" alt="${item}" title="${item}" type="face">`;

                            break;
                        }
                    }
                    if (src) {
                        str = str.replace(pattern2, src);
                    }
                }
            } else {
                return str;
            }

            return str;
        },
        handleClickUserPage() {
            this.openNative('person_page',{
              id: this.live_info.l_id,
			  o_kind: "live_msg",
              is_vip_service: 'yes',//是否投顾
            })
        },
		// 跳转研报页面
		goDetail(item) {
			console.info(item,'ITEM')
			this.openNative("reserach_report", {
				url: item.link
			})
		}
    }
}
</script>
<style scoped lang="scss">
@import "~@/assets/sass/global.scss";
@mixin setBottomLine($c: #c7c7c7) {
    & {
        position: relative;
    }

    &::after {
        content: " ";
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 1px;
        border-bottom: 1px solid $c;
    }

    [data-dpr="1"] &:before {
        transform-origin: 0 0;
        transform: scaleY(0.5);
    }
}

@mixin setTopLine($c: #c7c7c7) {
    & {
        position: relative;
    }

    &:before {
        content: " ";
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: rem2(1px);
        border-bottom: rem2(1px) solid $c;
    }

    [data-dpr="1"] &:before {
        transform-origin: 0 0;
        transform: scaleY(0.5);
    }
}

.live_item {
    background: $a-white;
    padding-bottom: rem2(6px);
    /* 强制英文长单词换行 */
    word-break: break-all;
    word-wrap: break-word;

    /* 仅自己可见 */
    .is_only_self_show {
        height: rem2(34px);
        background-image: url("../../assets/images/icon_only_self_show@2x.png");
        background-repeat: no-repeat;
        background-size: rem2(12px) rem2(14px);
        background-position: rem2(12px) rem2(10px);
        text-indent: rem2(30px);
        color: #919191;
        line-height: rem2(34px);
        font-size: rem2(14px);
        width: 100%;
        @include setBottomLine($a-bordr-c);
    }

    /* 仅粉丝可见 */
    .is_only_fans_show {
        height: rem2(34px);
        background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/only_fans_show.svg");
        background-repeat: no-repeat;
        background-size: rem2(12px) rem2(14px);
        background-position: rem2(12px) rem2(10px);
        text-indent: rem2(30px);
        color: #919191;
        line-height: rem2(34px);
        font-size: rem2(14px);
        width: 100%;
        @include setBottomLine($a-bordr-c);
    }

    /* 头部样式 */
    .live_header {
        position: relative;
        padding: rem2(10px) rem2(12px);
		box-sizing: border-box;
        display: flex;
		width: 100%;
		height: auto;
		align-items: center;
        flex-wrap: wrap;

        .user_detail {
            display: flex;
			align-items:center;
			width: 100%;

            dt {
                width: rem2(41px);
                height: rem2(41px);
                border: rem2(0.5px) solid rgba(0, 0, 0, 0.07);;
                border-radius: 50%;
                margin-right: rem2(10px);
                overflow: hidden;
                box-sizing: border-box;

                >img {
                    width: 100%;
                    height: 100%;
                }
            }

            dd {
                flex: 1;

                h4 {
                    display: flex;
                    align-items: center;
                    margin: 0 0 rem2(5px) 0;

                    .user_name {
                        font-size: rem2(15px);
                        color: $a-normal;
                        font-weight: 400;
                        height: rem2(18px);
                        line-height: rem2(18px);
                    }

                    .user_symbol {
                        width: rem2(14px);
                        height: rem2(14px);
                        margin-left: rem2(8px);
                        line-height: 0;

                        >img {
                            width: 100%;
                            height: 100%;
                            display: block;
                        }
                    }
                }

                p {
                    font-size: rem2(12px);
                    line-height: rem2(16px);
                    color: #939393;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
            }
			
			.right_btns {
				margin-left: auto;
				display: flex;
				flex-direction: row;
				align-items: center;
				
				// 开通会员
				.open_vip {
					width: 53px;
					height: 22px;
					border-radius: 3px;
					border: 1px solid #FF443D;
					font-size: 12px;
					line-height: 22px;
					color: #FF443D;
					text-align: center;
					background-color: transparent;
					outline: none;
					margin-right: 8px;
				}
				
				// 私信
				.letter_msg {
					width: 50px;
					height: 22px;
					border-radius: 3px;
					border: 1px solid #DCDCDC;
				    color: #AFAFAF;
					outline: none;
					background-color: transparent;
					font-size: 12px;
					font-weight: 400;
					margin-right: 8px;
				}
				
				// 关注状态
				.blockdivFollow {
					width: 50px;
				    height: 22px;
				    border-radius: 3px;
				    border: 1px solid #DCDCDC;
				    outline: none;
				    font-size: 12px;
				    font-weight: 400;
				    line-height: 22px;
				    text-align: center;
				    color: #AFAFAF;
					padding: 0;
					box-sizing: border-box;
					background-repeat: no-repeat;
					background-color: transparent;
				
				    /* 未关注 */
				    &.is_no_follow {
						background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/user_home_page_follow_add_icon.svg");
						background-position: 8px center;
						padding-left: 10px;
						background-size: 8px 8px;
						border: 1px solid #FF443D;
						color: #FF443D;
				    }
				
				    /* 已关注 */
				    &.is_follow {
						
				    }
				
				    /* 特别关注 */
				    &.is_special {
				        width: 70px;
				    }
				}
			}
        }

        .user_operation {
            width: rem2(14px);
            height: rem2(2px);
            margin-right: rem2(3px);

            img {
                width: 100%;
                height: 100%;
            }
        }
    }

    .live_content_box {
        background-color: transparent;
     
        /*视频专辑样式*/
        .video_special {
            padding: rem2(6px) rem2(14px) 0;

            .video_cover {
                height: rem2(198px);
                position: relative;

                >img {
                    width: 100%;
                    height: 100%;
                }

                .play_btn {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    margin-top: rem2(-23px);
                    margin-left: rem2(-23px);
                    width: rem2(47px);
                    height: rem2(47px);

                    >img {
                        width: 100%;
                        height: 100%;
                    }
                }
            }

            .video_special_detail {
                display: flex;
                box-sizing: content-box;
                height: rem2(60px);
                justify-content: space-between;
                padding: 0 rem2(10px);
                background: #f5f6f7;

                >div {
                    height: 100%;
                    display: flex;
                    flex-direction: column;

                    >h4 {
                        height: rem2(17px);
                        font-size: rem2(15px);
                        color: #222222;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        font-weight: 400;
                        margin: rem2(10px) 0 rem2(8px) 0;
                        line-height: rem2(17px);
                    }

                    >p {
                        font-size: rem2(14px);
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        color: #636363;
                        font-size: rem2(13px);
                    }
                }

                >dl {
                    flex-shrink: 0;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;

                    >dt {
                        width: rem2(27px);
                        height: rem2(22px);
                        margin: rem2(9px) 0 rem2(6px) 0;

                        >img {
                            width: 100%;
                            height: 100%;
                        }
                    }

                    >dd {
                        font-size: rem2(14px);
                        color: #fe696b;
                    }
                }
            }
        }

        /* 会员消息不能看全部的样式 */
        .members_only {
            .members_only_free {
                padding: rem2(6px) rem2(14px) 0;
                color: $a-222222-F3F3F3;
                font-size: rem2(16px);
                line-height: rem2(24px);

                &.small, &.litter {
                    font-size: rem2(14px);
                    line-height: rem2(18px);
                }

                &.middle {
                    font-size: rem2(18px);
                    line-height: rem2(24px);
                }

                &.big {
                    font-size: rem2(20px);
                    line-height: rem2(26px);
                }

                .user_name {
                    color: #507daf;
                    margin-right: rem2(5px);
                }
            }

            .transpond {
                background: $a-white;
            }

            .members_only_box {
                padding: rem2(10px) rem2(12px);

                &> div {
                    background-color: $a-FEFBF6-1E1E1E;
                    border: rem2(0.5px) solid $a-FFE4CE-222;
                    padding: rem2(7px) rem2(15px) rem2(11.5px);
                    box-sizing: border-box;

                    &> p {
                        color: #F68532;
                        font-size: rem2(12px);
                        font-weight: 400;
                        line-height: rem2(16px); /* 133.333% */
                    }
                }

                .vip_nosee_company {
                    height: rem2(50.5px);
                    display: flex;
                    border-top: rem2(.5px) solid $a-FFE4CE-222;
                    margin-top: rem2(7px);

                    & > span {
                        width: rem2(28.5px);
                        height: rem2(33px);
                        background: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/vip_msg_lock.svg");
                        margin-right: rem2(14.5px);
                        margin-left: 0;
                        background-size: 100%;
                        background-repeat: no-repeat;
                        margin-top: rem2(13.5px);
                    }

                    & > div {
                        margin-top: 10px;

                        & > p {
                            color: #939393;
                            text-align: justify;
                            font-size: rem2(14px);
                            font-style: normal;
                            font-weight: 400;
                            line-height: rem2(21px); /* 150% */

                            &.vip_nosee_company_small {
                                font-size: rem2(12px);
                            }
                        }
                    }

                    .vip_company_info {
                        margin-left: auto;
                        display: flex;
                        flex-direction: column;
                        width: rem2(80px);
                        height: rem2(39px);
                        flex-shrink: 0;
                        border-radius: rem2(5px);
                        background-color: #FE484A;
                        align-items: center;
                        margin-top: rem2(11.5px);
                        justify-content: center;

                        & > span {
                            color: #FFF;
                            text-align: justify;
                            font-size: rem2(13px);
                            font-style: normal;
                            font-weight: 400;
                            line-height: rem2(16px); /* 160% */

                            &.vip_company_info_small {
                                font-size: rem2(10px);
                            }
                        }
                    }
                }
            }
        }

        /* 会员消息可看全部的样式 */
        .member_brief {
            font-size: rem2(16px);
            line-height: rem2(22px);
            padding: 0 rem2(12px) 0;
            color: #636363;

            &.small, &.litter {
                font-size: rem2(14px);
                line-height: rem2(18.25px);
            }

            &.middle {
                font-size: rem2(20px);
                line-height: rem2(27.5px);
            }

            &.big {
                font-size: rem2(24px);
                line-height: rem2(33px);
            }

            .user_name {
                color: #507daf;
                margin-right: rem2(5px);
            }
        }

        .member_pad {
            height: rem2(15px);
            width: 100%;
        }

        .transpond {
            background: $a-white;
        }

        .member_news_box {
            padding: 0 rem2(12px);
            box-sizing: border-box;

            .member_news {

                .member_news_header {
                    height: rem2(32px);
                    box-sizing: border-box;
                    display: flex;
                    align-items: center;
                    margin: 0;
                    border-radius: rem2(1px);
                    border: rem2(0.5px) solid $a-FFE4CE-222;
                    background: $a-FEFBF6-1E1E1E;

                    >dl {
                        width: 100%;
                        height: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        >dt {
                            width: rem2(15px);
                            height: rem2(15px);
                            flex-shrink: 0;

                            >img {
                                width: 100%;
                                height: 100%;
                                display: block;
                            }
                        }

                        >dd {
                            display: flex;
                            flex-direction: column;
                            justify-content: space-between;
                            margin-left: rem2(5px);

                            >h4 {
                                color: #F68532;
                                font-size: rem2(13px);
                                line-height: rem2(32px);
                            }
                        }
                    }
                }

                .member_news_contents {
                    color: $a-normal;
                    font-size: rem2(16px);
                    line-height: rem2(22px);
                    padding: rem2(15px) 0 0;
    
                    &.small, &.litter {
                        font-size: rem2(14px);
                        line-height: rem2(18.25px);
                    }
    
                    &.middle {
                        font-size: rem2(20px);
                        line-height: rem2(27.5px);
                    }
    
                    &.big {
                        font-size: rem2(24px);
                        line-height: rem2(33px);
                    }
                }
            }

            .img_box {

                .thumbnail {
                    padding: 0;
                }
            }
        }
    }

    /* 附件 */
    .file_wrap24_wrap {
        width: 100%;
        height: auto;
        padding: rem2(10px) rem2(12px) 0;
        box-sizing: border-box;

        .file_wrap24 {
            flex-shrink: 0;
            margin-right: rem2(5px);
            background-color: #F6F6F6;

            .file_wrap{
                display: inline-flex;
                margin-bottom:rem2(0px);
                align-items: center;
                width: 100%;

                .file_box{
                    width: 100%;
                    height: rem2(36px);
                    line-height: rem2(36px);
                    display: flex;
                    align-items: center;
                    font-size: rem2(13px);
                    font-weight: 400;
                    color: #636363;
                    padding-right: rem2(12.15px);
                    box-sizing: border-box;

                    .file_box_img{
						width: rem2(14px);
						height: rem2(16.62px);
                        background: url("https://cdncos.aigupiao.com/assets/pc/svg/upload/mp3_.svg");
                        background-size: 100%;
                        margin: 0 rem2(9.5px) 0 rem2(10px);
                    }
                    .pdf_img{
                        background: url("https://cdncos.aigupiao.com/assets/pc/svg/upload/pdf_.svg");
                        background-size: 100%;
                    }
                    .doc_img, .docx_img {
                        background: url("https://cdncos.aigupiao.com/assets/pc/svg/upload/word_.svg");
                        background-size: 100%;
                    }
                    .xls_img, .xlsx_img {
                        background: url("https://cdncos.aigupiao.com/assets/pc/svg/upload/xlsx_.svg");
                        background-size: 100%;
                    }
                    .ppt_img, .pptx_img {
                        background: url("https://cdncos.aigupiao.com/assets/pc/svg/upload/ppt_.svg");
                        background-size: 100%;
                    }
                    .txt_img {
                        background: url("https://cdncos.aigupiao.com/assets/pc/svg/upload/txt_.svg");
                        background-size: 100%;
                    }

                    .file_box_download{
                        width: rem2(11.85px);
                        height: rem2(15px);
                        border: none;
                        outline: none;
                        padding: 0;
                        background-color: transparent;
                        background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/downloadFile.svg");
                        background-repeat: no-repeat;
                        background-position: center;
                        background-size: 100%;
                    }

                    .file_box_view_rf { 
                        flex: 1;
                        display: inline-flex;
                        align-items: center;

                        p {
                            font-size: rem2(14px);
                            font-weight: 400;
                            color: #636363;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            max-width: rem2(150px);
                        }

                        span {
                            color: #939393;
                            margin-left: rem2(10px);
                        }
                    }
                }
            }
        }
    }

    /* 著作权声明 */
    .statement_wrap {
        border-top: rem2(0.5px) solid $a-bordr-c;
        margin-top: rem2(20px);
        padding: rem2(12px);

        p {
            font-size: rem2(12px);
            line-height: rem2(16.8px);
            color: #AFAFAF;
        }
    }

    /* 赞赏 - 点赞 */
    .appreciate_support_wrap {
        width: 100%;
        height: auto;
        padding: rem2(15px) rem2(20px);
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;

        button {
            width: rem2(110px);
            height: rem2(38px);
            border: rem2(1px) solid #FF443D;
            border-radius: rem2(19px);
            background-color: transparent;
            outline: none;
            margin-right: rem2(9.42px);
            background-repeat: no-repeat;
            background-color: transparent;
            background-size: rem2(18px) rem2(18px);
            font-size: rem2(12.5px);
            color: #FD5356;
            padding-left: rem2(24px);

            &.appreciate_btn {
                background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/appreciate_icon.svg");
                background-position: rem2(30.5px) center;
				
				&.is_new {
					position: relative;
					&::before{
						content: "";
						position: absolute;
						width: rem2(25.5px);
						height: rem2(16.5px);
						background-color: transparent;
						background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/appreciate_new_icon.svg");
						background-size: 100%;
						background-repeat: no-repeat;
						background-position: center;
						right: rem2(14.95px);
						top: rem2(-7.25px);
						z-index: 2;
					}	
				}
            }

            &.support_btn {
                background-position: rem2(35.5px) center;
                background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/detail_support.svg");
                margin-right: 0;

                &.is_support {
                    background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/detail_is_support.svg");
                }
            }
        }
    }

    /* 赞赏列表 */
    .reward_wrap {
        width: 100%;
        height: auto;
        box-sizing: border-box;
        padding: 0 rem2(12px);

        & > p {
            overflow: hidden;
            color: #939393;
            text-align: center;
            text-overflow: ellipsis;
            font-size: rem2(12px);
            line-height: rem2(17px);
            font-weight: 400;
        }

        & > .reward_wrap_list {
            margin-top: rem2(10px);
            width: 100%;
            height: auto;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: center;

            &.bindLeft {
                justify-content: flex-start;
            }

            & > div {
                width: rem2(26px);
                height: rem2(26px);
                border-radius: 50%;
                background-color: transparent;
                background-size: cover;
                background-repeat: no-repeat;
                background-position: center;
                margin-right: rem2(8px);
                margin-bottom: rem2(8px);
            }
        }
    }

    /* 分享到 朋友圈 - 微信 - QQ - 微博 */
    .share_list {
        width: 100%;
        height: rem2(40px);
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;

        span {
            font-size: rem2(13.5px);
            font-weight: 400;
            color: #939393;
        }

        button {
            width: rem2(26px);
            height: rem2(26px);
            margin-left: rem2(20px);
            border: none;
            outline: none;
            background-color: transparent;
            background-repeat: no-repeat;
            background-position: center;
            background-size: rem2(26px) rem2(26px);

            &.Moments {
                background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/share_moment.svg");
            }

            &.WeChat {
                background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/share_wechat.svg");
            }

            &.QQ {
                background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/share_qq.svg");
            }

            &.WeiBo {
                background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/share_weibo.svg");
            }
        }
    }

    /* 风险提示 */
    .risk_hint {
        border-top: rem2(0.5px) solid $a-bordr-c;
        padding: rem2(10px) rem2(14px) rem2(9.5px) rem2(11px);
        box-sizing: border-box;

        p {
            color: #939393;
            font-size: rem2(12px);
            font-style: normal;
            font-weight: 400;
            line-height: rem2(16px);
        }
    }
	
	/* 参考研报 */
	.research_report {
		width: 100%;
		height: auto;
		padding: 20px 12px 0;
		box-sizing: border-box;
		color: $a-normal;
		font-size: 15px;
		line-height: 22px;
		
		p {
			color: $a-normal;
			font-size: 16px;
			line-height: 22px;
			margin-bottom: 5px;
		}
		
		& > div {
			width: 100%;
			height: auto;
			
			.research_wrap {
				width: 100%;
				height: auto;
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: space-between;
				
				.research_left {
					flex: 1;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}
				
				.research_right {
					width: auto;
					display: flex;
					flex-direction: row;
					align-items: center;
					justify-content: flex-end;
					
					span {
						font-size: 15px;
						color: rgb(124,119,125);
						
						&.research_pub_time {
							margin-left: 5px;
						}
					}
				}
			}
		}
	}
}
</style>
<style lang="scss">
.vip_group_wrap {
    text-align: left;
}
.vip_group_wrap_center {
    text-align: center;
}

.van-dialog.custom-dialog {
    width: 250px;
    .van-dialog__header{
        padding-top: 20px;
    }
}

.special_column_content ol {
    list-style-type: decimal;

    li {
        margin-left: 20px;
        list-style-type: decimal;
    }
}

span.p-url-link {
    color: #1D88D0;
    background-image: url(https://img1-cdn-picsh.aigupiao.com/m/image_lib/2026-06-01/650de000d8fe935721650736f0721601=28X28.png);
    background-repeat: no-repeat;
    background-position: 0 center;
    background-size: 14px;
    padding-left: 18px;
    margin: 0 5px;
}
</style>